import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  LdapSettingUrl: '/api/sm/auth/ldap-cm', // LDAP 설정 URL
  LdapSyncUrl: '/api/sm/auth/ldap-cm/sync', // LDAP 사용여부 설정 URL
  LdapUrl: '/api/sm/auth', // LDAP URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // LDAP 조회 리스트

  // ldapdServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {} // 수정중인 항목 모든탭 동일
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // LDAP 조회 리스트
    state.selectedStoreItem = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // LDAP 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_ldap_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_ldap_cm_id === data.authsvr_ldap_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_ldap_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_ldap_cm_id: p.authsvr_ldap_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getLdapDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addLdapData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editLdapData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_ldap_id: item.authsvr_ldap_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delLdapDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_ldap_id: p.authsvr_ldap_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.LdapSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 통합 설정 추가
    try {
      const data = await this.$axios.$put(state.LdapSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.LdapSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_ldap_cm_id': item.authsvr_ldap_cm_id})
      delList.push(item.authsvr_ldap_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.LdapSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.LdapSettingUrl}/${payload[0].authsvr_ldap_cm_id}`)

      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.LdapSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.LdapSyncUrl}/${payload[0].authsvr_ldap_cm_id}`, _.pick(payload[0], ['authsvr_ldap_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.LdapSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // LDAP //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getLdapDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.LdapUrl}/${state.defaultId}/ldap`)
      return resultFactory(commit, {length: null, data: data, action: 'getLdapDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addLdapData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload), 'add')
    try {
      const data = await this.$axios.$post(`${state.LdapUrl}/${state.defaultId}/ldap`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addLdapData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editLdapData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload), 'edit')
    try {
      const data = await this.$axios.$put(`${state.LdapUrl}/${state.defaultId}/ldap/${payload.authsvr_ldap_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editLdapData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delLdapDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_ldap_id': item.authsvr_ldap_id})
      delList.push(item.authsvr_ldap_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.LdapUrl}/${state.defaultId}/ldap`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.LdapUrl}/${state.defaultId}/ldap/${payload[0].authsvr_ldap_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delLdapDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // LDAP //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param, type) {
  const serverKeyMap = {
    name: 'ldap_svr_name',
    ip: 'ldap_svr_ip',
    port: 'ldap_svr_port',
    ldap_svr_id: 'ldap_svr_id'
  }
  const server = []
  _.forEach(param.servers, (item) => {
    server.push(_.omit(_.mapKeys(item, (value, key) => {
      return serverKeyMap[key]
    }), ['undefined', 'itemIndex']))
  })
  param.servers = server

  if (type === 'add') {
    param.authsvr_ldap_passwd = btoa(param.passwd)
  } else {
    if (param.passwd.length > 0) {
      param.authsvr_ldap_passwd = btoa(param.passwd)
    }
  }

  const payloadKeyMap = {
    authsvr_ldap_id: 'authsvr_ldap_id',
    name: 'authsvr_ldap_name',
    base_dn: 'authsvr_ldap_base_dn',
    bind_dn: 'authsvr_ldap_bind_dn',
    conn_type: 'authsvr_ldap_conn_type',
    account_type: 'authsvr_ldap_account_type',
    tm_limit: 'authsvr_ldap_tm_limit',
    bind_tm_limit: 'authsvr_ldap_bind_tm_limit',
    retry_intval: 'authsvr_ldap_retry_intval',
    auth_only: 'authsvr_ldap_auth_only',
    is_sec_group_use: 'authsvr_ldap_is_sec_group_use',
    sec_group: 'authsvr_ldap_sec_group',
    use_admin_level_check: 'authsvr_ldap_use_admin_level_check',
    use_admin_ip_check: 'authsvr_ldap_use_admin_ip_check',
    desc: 'authsvr_ldap_desc',
    servers: 'servers',
    authsvr_ldap_passwd: 'authsvr_ldap_passwd'
  }
  return _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])
}
